import React from 'react';
import { AuthLayout } from '../../components/layout/AuthLayout';
import { LoginForm } from '../../features/auth/LoginForm';

export const LoginPage = () => {
  return (
    <AuthLayout
    >
      <LoginForm />
    </AuthLayout>
  );
};
